import { Coordinate, Trip } from "@fairfleet/geotab";
import Skeleton from "@mui/material/Skeleton";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useAddresses } from "@/hooks/addresses/useAddresses";

export function StopAddressCell(props: GridRenderCellParams<Trip>) {
  const stopPoint = props.row?.stopPoint as Coordinate | undefined;
  const { data: addresses, isLoading } = useAddresses(stopPoint ? [stopPoint] : []);

  if (!stopPoint) {
    return <></>;
  }

  if (isLoading || !addresses) {
    return <Skeleton width="100%" variant="text" />;
  }

  return <>{addresses[0]?.formattedAddress}</>;
}
